import axios from 'axios'

export default {
  getAccountStatuses () {
    return axios.get('/api/v1/account_statuses')
  },
}
